import React from 'react'
import { Image } from '../../elements/Image'
import { DefaultSizeOptions, Text } from '../../elements/Text'
import styles from './styles.scss'
import { IProps } from './index'
import useTranslate from 'marketing-site/src/library/hooks/useTranslate'

export function WebinarSeriesHero({ heading, subheading, image }: IProps) {
  const { translate } = useTranslate()

  return (
    <div className="webinar-series-hero">
      <div className="webinar-series-hero__wrapper">
        <div className="webinar-series-hero__content">
          <a className="webinar-series-hero__eyebrow" href={'/webinars'}>
            <Text brand="default" size="eyebrows">
              {translate('Webinars ›')}
            </Text>
          </a>
          <h1 className="webinar-series-hero__heading">
            <Text brand="default" size={'heading-1-small' as DefaultSizeOptions}>
              {heading}
            </Text>
          </h1>
          {subheading && (
            <div className="webinar-series-hero__subheading">
              <Text brand="default" size="heading-4">
                {subheading}
              </Text>
            </div>
          )}
        </div>
        <div className="webinar-series-hero__asset-container">
          <div className="webinar-series-hero__asset">
            <Image {...image} borderRadius={25} />
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}
